export enum ECommonCountries {
    CZ = 'CZ',
    SK = 'SK'
}
